import React, { forwardRef } from 'react';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid'
import { Field } from '../../../configuration';

interface SelectProps extends Field {
    placeholder?: string;
    value?: string;
    onChange?: (newValue: string) => void;
}

const Select = forwardRef(({ name, placeholder, options, value, onChange }: SelectProps, ref) => {

    return (
        <Listbox ref={ref} name={name} value={value} onChange={onChange}>
            {({ open }) => (
                <div className="relative mt-2">
                    <ListboxButton className="bg-white relative px-7 h-14 text-left rounded-full w-full shadow-leap focus:ring-2 focus:ring-brand outline-none">
                        <span
                            className={`block pr-6 truncate text-font-400 ${value ? ' text-novartis-font' : ' text-novartis-font'}`}>
                            {value || placeholder}
                        </span>
                        <span className="absolute inset-y-0 right-0 flex items-center pr-6 pointer-events-none">
                            { open
                              ? (<ChevronUpIcon aria-hidden="true" className="h-8 w-8 text-novartis-font" />)
                              : ((<ChevronDownIcon aria-hidden="true" className="h-8 w-8 text-novartis-font" />))
                            }
                        </span>
                    </ListboxButton>
                    <ListboxOptions className="absolute z-10 mt-1 max-h-60 w-full bg-neutral rounded-md py-1  shadow-leap ring-1 ring-brand ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                        {options?.map((option, index) => (
                          <ListboxOption
                          className={({ active }) =>
                             `cursor-default relative py-1 pl-3 pr-9 ${
                                active
                                   ? ' text-font-contrast font-bold bg-brand rounded-md mx-1'
                                   : ' text-novartis-font font-normal'
                             }`
                          }
                          key={index}
                          value={option.value}
                        >
                          {option.label}
                        </ListboxOption>
                        ))}
                    </ListboxOptions>
                </div>
            )}
        </Listbox>
    );
});

export default Select;